import DynamicContentsForm from '../DynamicContentsForm';

export default DynamicContentsForm;
